import { render, staticRenderFns } from "./KnowledgeItemsView.vue?vue&type=template&id=f87b108e"
import script from "./KnowledgeItemsView.vue?vue&type=script&lang=js"
export * from "./KnowledgeItemsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports